// ============================================================
// AssistantBar-Engine — PCM-/Audio-Hilfen der Sprachsitzung.
// 1:1 aus AssistantBar.js (Vanilla) hierher verschoben.
// ============================================================

// ── helper: PCM tabdil ──
// (floatTo16BitPCM war schon in der Vanilla-Datei vorhanden, aber seit dem
// AudioWorklet-Umbau ungenutzt — der Worklet liefert bereits Int16-Frames.
// Bewusst mitgenommen statt gelöscht: reine Code-Verschiebung.)
export function floatTo16BitPCM(f: Float32Array): Int16Array {
  const out = new Int16Array(f.length);
  for (let i = 0; i < f.length; i++) { const s = Math.max(-1, Math.min(1, f[i])); out[i] = s < 0 ? s * 0x8000 : s * 0x7FFF; }
  return out;
}
export function abToB64(buf: ArrayBuffer): string {
  let s = ''; const b = new Uint8Array(buf);
  for (let i = 0; i < b.length; i++) s += String.fromCharCode(b[i]);
  return btoa(s);
}
export function b64ToAb(b64: string): ArrayBuffer {
  const bin = atob(b64); const b = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) b[i] = bin.charCodeAt(i);
  return b.buffer;
}

// ── Lautstärke: Gemini liefert eher leises PCM — ein GainNode hebt es an,
// der Kompressor dahinter fängt Spitzen ab (sonst würde Verstärkung >1 bei
// lauten Stellen hörbar knacken/clippen). Wert überschreibbar via
// localStorage «levelupwerk:voice-volume» (z.B. 1 = Original, 3 = sehr laut).
export const VOICE_VOLUME_KEY = 'levelupwerk:voice-volume';
export function voiceVolume(): number {
  try {
    const v = parseFloat(localStorage.getItem(VOICE_VOLUME_KEY) || '');
    if (Number.isFinite(v) && v >= 0.5 && v <= 4) return v;
  } catch { /* Privatmodus */ }
  return 2; // Standard: doppelt so laut wie bisher
}
